import { render, staticRenderFns } from "./HelpData.vue?vue&type=template&id=6c784a0a"
import script from "./HelpData.vue?vue&type=script&lang=js"
export * from "./HelpData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports